export default __webpack_public_path__ + "static/media/vr-tracking-sdk.95ccf0f6.jpg";